// extracted by mini-css-extract-plugin
module.exports = {"swiper-navigation-disabled":"hK9mCt"};